import React from 'react';
import { Check, Copy } from 'lucide-react';

export const CopyIcon = ({ className }: { className?: string }) => (
    <Copy className={className} strokeWidth={1.5} />
);

export const CheckIcon = ({ className }: { className?: string }) => (
    <Check className={className} strokeWidth={1.5} />
);
